<template>
  <div class="flex p-1.5 rounded-full bg-grey-light-50 border border-grey-light-200 w-fit mx-auto">
    <div
      v-for="product in products"
      :key="product.name"
      @click="onSelectProduct(product.name)"
      :class="[
        'flex items-center justify-center rounded-full h-[47px] px-6 hover:cursor-pointer',
        themeStore.current === product.name ? 'bg-primary custom-shadow' : '',
      ]"
    >
      <img
        :class="[
          product.logoClass,
          { 'logo-grey-light-400': themeStore.current !== product.name },
        ]"
        :src="product.logo"
        :alt="product.alt"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import boostWhite from '@/assets/images/boost-logo-white.svg';
import laybyWhite from '@/assets/images/layby-logo-white.svg';
// import plansWhite from '@/assets/images/plans-logo-white.svg';
import { useThemeStore } from '@/stores/theme';
import { useRouter } from 'vue-router';

const themeStore = useThemeStore();
const router = useRouter();

const products: { name: 'layby' | 'boost'; logo: string; alt: string; logoClass: string }[] = [
  {
    name: 'layby',
    logo: laybyWhite,
    alt: 'LayBy Logo',
    logoClass: 'w-[97px] h-[37px]',
  },
  /*{
    name: 'plans',
    logo: plansWhite,
    alt: 'Plans Logo',
    logoClass: 'w-[82px] h-[20px]',
  },*/
  {
    name: 'boost',
    logo: boostWhite,
    alt: 'Boost Logo',
    logoClass: 'w-[70px] h-[25px]',
  },
];

const onSelectProduct = (productName: 'layby' | 'boost') => {
  themeStore.setProduct(productName);

  const currentPath = router.currentRoute.value.path;
  const newPath = currentPath.replace(/^\/(layby|boost)/, `/${productName}`);
  router.push(newPath === currentPath ? `/${productName}` : newPath);
};
</script>

<style scoped>
.custom-shadow {
  box-shadow:
    0 1.07px 3.21px rgba(16, 24, 40, 0.1),
    0 1.07px 2.14px rgba(16, 24, 40, 0.06);
}

.logo-grey-light-400 {
  filter: brightness(0) saturate(100%) invert(71%) sepia(13%) saturate(364%) hue-rotate(188deg) brightness(95%) contrast(87%);
}
</style>
